module.exports = __webpack_public_path__ + "files/c85c8df0cff19daea704b1905a6ae5ac.svg";